import { createSlice } from '@reduxjs/toolkit'
import { ModalStatus } from 'models/enum'
import { powerPlantLimitationApi } from 'services/api'

const initialState = {
  limitList: {},
  isListLoading: false,
  isEntityLoading: false,
  powerPlantLimitationById: {},
  powerPlantLimitationModalStatus: ModalStatus.Hidden,
  error: null
}

const powerPlantLimitationSlice = createSlice({
  name: 'powerPlantLimitation',
  initialState,
  reducers: {
    // List
    getLimitListStart (state) {
      state.error = null
      state.isListLoading = true
    },
    getLimitListSuccess (state, { payload }) {
      state.limitList = payload
      state.error = null
      state.isListLoading = false
    },
    getLimitListFailed (state, { payload }) {
      state.limitList = {}
      state.error = payload.customError
      state.isListLoading = false
    },
    // GET
    getPowerPlantLimitationStart (state) {
      state.error = null
      state.isEntityLoading = true
    },
    getPowerPlantLimitationSuccess (state, { payload }) {
      state.powerPlantLimitationById = payload
      state.error = null
      state.isEntityLoading = false
    },
    getPowerPlantLimitationFailed (state, { payload }) {
      state.powerPlantLimitationById = {}
      state.error = payload.error
      state.isEntityLoading = false
    },
    // CREATE
    createPowerPlantLimitationStart (state) {
      state.error = null
      state.isEntityLoading = true
    },
    createPowerPlantLimitationSuccess (state) {
      state.powerPlantLimitationById = {}
      state.error = null
      state.powerPlantLimitationModalStatus = ModalStatus.Hidden
      state.isEntityLoading = false
    },
    createPowerPlantLimitationFailed (state, { payload }) {
      state.error = payload.error
      state.isEntityLoading = false
    },
    // EDIT
    editPowerPlantLimitationStart (state) {
      state.error = null
      state.isEntityLoading = true
    },
    editPowerPlantLimitationSuccess (state) {
      state.powerPlantLimitationById = {}
      state.error = null
      state.powerPlantLimitationModalStatus = ModalStatus.Hidden
      state.isEntityLoading = false
    },
    editPowerPlantLimitationFailed (state, { payload }) {
      state.error = payload.error
      state.isEntityLoading = false
    },

    // DELETE
    deletePowerPlantLimitationSuccess (state) {
      state.error = null
    },
    deletePowerPlantLimitationFailed (state, { payload }) {
      state.error = payload.error
    },

    // Modal
    setPowerPlantLimitationModalStatus (state, { payload }) {
      state.powerPlantLimitationModalStatus = payload
    },
    clear (state) {
      state.limitList = {}
      state.powerPlantLimitationById = {}
      state.isEntityLoading = false
      state.powerPlantLimitationModalStatus = ModalStatus.Hidden
      state.error = null
    }
  }
})

const {
  getLimitListStart,
  getLimitListSuccess,
  getLimitListFailed,
  getPowerPlantLimitationStart,
  getPowerPlantLimitationSuccess,
  getPowerPlantLimitationFailed,
  createPowerPlantLimitationStart,
  createPowerPlantLimitationSuccess,
  createPowerPlantLimitationFailed,
  editPowerPlantLimitationStart,
  editPowerPlantLimitationSuccess,
  editPowerPlantLimitationFailed,
  deletePowerPlantLimitationSuccess,
  deletePowerPlantLimitationFailed,
  setPowerPlantLimitationModalStatus,
  clear
} = powerPlantLimitationSlice.actions

const getPowerPlantLimitationList = (params) => {
  return async (dispatch) => {
    try {
      dispatch(getLimitListStart())
      const list = await powerPlantLimitationApi.getPaginatedPowerPlantLimitation(params)
      dispatch(getLimitListSuccess(list))
    } catch (customError) {
      dispatch(getLimitListFailed({ customError }))
    }
  }
}

const getPowerPlantLimitation = (id) => async dispatch => {
  try {
    dispatch(getPowerPlantLimitationStart())
    const powerPlantLimitationById = await powerPlantLimitationApi.getPowerPlantLimitation({ id })
    dispatch(getPowerPlantLimitationSuccess(powerPlantLimitationById))
  } catch (error) {
    dispatch(getPowerPlantLimitationFailed({ error }))
  }
}

const createPowerPlantLimitation = (createPowerPlantLimitationDto) => async dispatch => {
  try {
    dispatch(createPowerPlantLimitationStart())
    await powerPlantLimitationApi.createPowerPlantLimitation({ createPowerPlantLimitationDto })
    dispatch(createPowerPlantLimitationSuccess())
    dispatch(getPowerPlantLimitationList())
  } catch (error) {
    dispatch(createPowerPlantLimitationFailed({ error }))
  }
}

const editPowerPlantLimitation = (id, updatePowerPlantLimitationDto) => async dispatch => {
  try {
    dispatch(editPowerPlantLimitationStart())
    await powerPlantLimitationApi.updatePowerPlantLimitation(
      { id, updatePowerPlantLimitationDto })
    dispatch(editPowerPlantLimitationSuccess())
    dispatch(getPowerPlantLimitationList())
  } catch (error) {
    dispatch(editPowerPlantLimitationFailed({ error }))
  }
}

const deletePowerPlantLimitation = (id) => async dispatch => {
  try {
    await powerPlantLimitationApi.deletePowerPlantLimitation({ id })
    dispatch(deletePowerPlantLimitationSuccess())
    dispatch(getPowerPlantLimitationList())
  } catch (error) {
    dispatch(deletePowerPlantLimitationFailed({ error }))
  }
}

export {
  getPowerPlantLimitationList,
  getPowerPlantLimitation,
  createPowerPlantLimitation,
  editPowerPlantLimitation,
  deletePowerPlantLimitation,
  setPowerPlantLimitationModalStatus,
  clear
}

export default powerPlantLimitationSlice.reducer
